import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";

const Notification = () => {
  const fileInputRef = useRef(null);
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: null,
    title: "",
    description: "",
    image: null,
    image_url: "",
  });

  const onSave = () => {
    if (isValidForm()) {
      setError(false);
      setLoading(true);
      axios
        .post(API_URL.NOTIFICATION, {
          title: formData.title,
          description: formData.description,
          image: formData.image
        })
        .then((res) => {
          if (res.data.status === 1) {
            let message = "Notification Sent Successfully."
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            setFormData({
              id: null,
              title: "",
              description: "",
              image: null,
              image_url: "",
            });
            fileInputRef.current.value = null;
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(true);
        })
        .finally(() => {
          setLoading(false);
          setError(false);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const isValidForm = () => {
    if (!formData.title || !formData.description) return false;
    return true;
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>Add Notification</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Title<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    className={
                      isRequiredField("title")
                        ? "form-control required"
                        : "form-control"
                    }
                    id="title"
                    onChange={(event) => {
                      setFormData({ ...formData, title: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Image</label>
                      <input
                        accept="image/*"
                        type="file"
                        ref={fileInputRef}
                        name="image"
                        className="form-control"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            const base64String = reader.result;
                            setFormData({
                              ...formData,
                              image: base64String,
                            });
                          };
                          reader.readAsDataURL(file);
                        }}
                      />
                    </div>
                  </div>
                  {formData.image_url && (
                    <div className="col-md-12">
                      <div>
                        <a
                          href={formData.image_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={formData.image_url}
                            height={100}
                            width={100}
                            alt="post_image"
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>
                    Message<span className="required-star">*</span>
                  </label>
                  <textarea
                    type="text"
                    name="description"
                    value={formData.description}
                    className={
                      isRequiredField("description")
                        ? "form-control required"
                        : "form-control"
                    }
                    id="description"
                    onChange={(event) => {
                      setFormData({ ...formData, description: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                <div className="text-end">
                  <Link
                    to={"/admin/notification"}
                    className={
                      loading
                        ? "btn btn-danger btn-sm me-2 disabled-link"
                        : "btn btn-danger btn-sm me-2"
                    }
                    onClick={(e) => loading && e.preventDefault()}
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={onSave}
                    disabled={loading}
                    className="btn btn-primary btn-sm"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {loading && (
                        <Watch color={"white"} height={15} width={15} />
                      )}
                      Submit
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Notification;
